import React from 'react';
import { ArrowUp, Phone, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-ferry-darker border-t border-white/5">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <Logo size={40} />
              <span className="text-xl font-bold text-white">
                FERRY <span className="text-ferry-crimson">INFRA</span>
              </span>
            </div>
            <p className="text-ferry-cream text-sm italic mb-4">
              Veilig werken aan de energie van morgen
            </p>
            <p className="text-ferry-gray-text text-sm leading-relaxed">
              Uw specialist in infrastructuuroplossingen voor de energiesector.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Navigatie</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', href: '#home' },
                { name: 'Over Ons', href: '#about' },
                { name: 'Diensten', href: '#services' },
                { name: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-ferry-gray-text hover:text-white text-sm transition-colors duration-200 hover:pl-1"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Diensten</h4>
            <ul className="space-y-3">
              {['Gas', 'Water', 'Elektra', 'Kabeltracés', 'Civiele Werken', 'Onderhoud & Beheer', 'Veiligheidsdiensten', 'Materieel & Logistiek'].map((service) => (
                <li key={service}>
                  <span className="text-ferry-gray-text text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-ferry-crimson flex-shrink-0" />
                <button
                  type="button"
                  onClick={() => { window.location.href = ['tel:', '+31', '638', '076', '889'].join(''); }}
                  className="text-ferry-gray-text hover:text-white text-sm transition-colors duration-200 cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  +31 (0) 6 38 07 68 89
                </button>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-ferry-crimson flex-shrink-0" />
                <a href="mailto:info@ferryinfra.nl" className="text-ferry-gray-text hover:text-white text-sm transition-colors duration-200">
                  info@ferryinfra.nl
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={14} className="text-ferry-crimson flex-shrink-0" />
                <span className="text-ferry-gray-text text-sm">Nederland</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ferry-gray-text text-xs">
            &copy; {new Date().getFullYear()} Ferry Infra. Alle rechten voorbehouden.
          </p>
          <button
            onClick={scrollToTop}
            className="w-10 h-10 rounded-xl bg-white/5 hover:bg-ferry-crimson/20 border border-white/10 hover:border-ferry-crimson/30 flex items-center justify-center transition-all duration-300 group"
          >
            <ArrowUp size={16} className="text-ferry-gray-text group-hover:text-ferry-crimson transition-colors" />
          </button>
        </div>
      </div>
    </footer>
  );
}
